module.exports = __webpack_public_path__ + "img/character_v.557f0621.svg";